import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.EduPrivacyToggler = class EduPrivacyToggler extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-privacy-toggler';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.applyContent();
    }

    setVars() {
        this.$switcher = this.$element.find('.js-switcher');
        this.$endpointUrl = this.$element.attr('data-endpoint-url');
        this.$togglerContentPlaceholder = this.$element.find('[data-toggler-content-placeholder]');
        this.$currentPrivacy = this.$element.attr('data-current-privacy');
    }

    setEventListeners() {
        this.$switcher.on('change', this.onSwitcherChange.bind(this));
    }

    onSwitcherChange() {
        this.$currentPrivacy = this.$currentPrivacy === 'private' ? 'public' : 'private';

        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => this.changePrivacyType(this.$currentPrivacy), {
                timeout: 1500
            });
        } else {
            this.changePrivacyType(this.$currentPrivacy);
        }
    }

    async changePrivacyType(currentPrivacy) {
        try {
            await $.ajax({
                context: this,
                type: 'POST',
                url: this.$endpointUrl,
                data: { profileType: currentPrivacy },
                success: this.onSuccess,
                error: this.onError
            });
        } catch (error) {
            this.onError.bind(this);
            console.error(error);
        }
    }

    applyContent() {
        let $templateSource = $(`#toggler-${this.$currentPrivacy}-template`).html();
        let $resultHtml = Handlebars.compile($templateSource);
        this.$togglerContentPlaceholder.html($resultHtml);
        this.$element.attr('data-current-privacy', this.$currentPrivacy);

        $(window).trigger('content:updated');
        $(window).trigger('gtm:send', [ 'My Profile', 'Make My Profile ' + this.$currentPrivacy]);
    }

    onSuccess() {
        this.applyContent();
    }

    onError() {
        setTimeout(() => {
            this.$switcher.prop('checked', this.$switcher.is(':checked') ? false : true);
        }, 1000);
    }
};



// WEBPACK FOOTER //
// ./components/edu-profile-privacy-toggler/scripts/edu-profile-privacy-toggler.js